import gql from "graphql-tag";
import ServicePreStayFragment from "graphql/PMS/Service/fragment/ServicePreStayFragment";
import HotelPublicFragment from "graphql/PMS/Hotel/fragment/HotelPublicFragment";
import OptionFragmentGql from "graphql/PMS/Option/fragment/OptionFragment.gql";
import ReservationPublicFragment from "graphql/PMS/Reservation/fragment/ReservationPublicFragment";
import CheckinDetailsFragmentGql from "graphql/PMS/Checkin/fragment/CheckinDetailsFragment.gql";

export default gql`

  ${OptionFragmentGql}
  ${ReservationPublicFragment}
  ${HotelPublicFragment}
  ${ServicePreStayFragment}
  ${CheckinDetailsFragmentGql}

  fragment PreStayPublicFragment on PreStay {
    id
    publicId
    preStayContent {
      arrival {
        arrivalMinutes
        arrivalHours
        charging
        parking
        transfert
        comment
        transfertData {
          isTrain
          isPlane
          trainStation
          trainNumber
          airport
          flightNumber
          terminal
          arrivalDate
        }
      }
      optionsSelected {
        quantity
        optionId
      }
      comment
      optionsComment
    }
    optionList {
      ...OptionFragment
    }
    serviceList {
      ...ServicePreStayFragment
    }
    Reservation {
      ...ReservationPublicFragment
    }
    Hotel {
      ...HotelPublicFragment
    }
    Checkin {
      ...CheckinDetailsFragment
    }
  }

`